import { Component } from '@angular/core';
import { LoadingSpinnerComponent } from '@ra-web-tech-ui-toolkit/components';

@Component({
  selector: 'app-spinner',
  styleUrls: ['./spinner.component.scss'],
  templateUrl: './spinner.component.html',
  imports: [LoadingSpinnerComponent],
})
export class SpinnerComponent {}
